<template>
  <generic-modal
    size
    :title="$t('wsdl method')"
    icon="concierge bell"
    image="/images/icons/soap.png"
    ref="modal"
    :show_ok="false"
    :scrolling="true"
  >
    <div class="description">
      <h2 class="ui header">
        <i class="concierge bell icon"></i>
        <div class="content">
          {{ setup.method }}
          <div class="sub header">
            <a :href="setup.service_url" target="_blank">{{ setup.service_url }}</a>
          </div>
        </div>
      </h2>
      <div class="ui segment">
        <div class="ui two column very relaxed grid">
          <div class="column">
            <h4 class="ui dividing header">{{ $t("request") }}</h4>
            <pre>{{ method_info.request }}</pre>
          </div>
          <div class="column">
            <h4 class="ui dividing header">{{ $t("response") }}</h4>
            <pre>{{ method_info.response }}</pre>
          </div>
        </div>
        <div class="ui vertical divider"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { local_api, stringify } from "@/utils";

export default {
  name: "WSDLMethodInfoModal",
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { setup: Object },
  data() {
    return {
      method_info: {},
      loading: true
    };
  },
  methods: {},
  mounted() {
    let vm = this;
    window.jQuery(vm.$el).modal({
      onHide() {
        vm.$emit("hidden");
      }
    });
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/ngine_composer/process/do-check-wsdl-method", {
      u: vm.setup.service_url,
      m: vm.setup.method
    })
      .then(r => {
        vm.method_info = r;
        vm.$refs.modal.set_loading(false);
      })
      .catch(err => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
  updated: function() {}
};
</script>
